export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./fontSize.vue?vue&type=template&id=dec7ad9e&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Settings/fontSize.vue?vue&type=template&id=dec7ad9e&
// module id = null
// module chunks = 